import { Breakpoints } from "../theme/Breakpoints";
import useWindowDimensions from "./useWindowDimensions";

const MOBILE_MAX_WIDTH = Number(Breakpoints.TABLET.replace("px", ""));

export default function useIsMobileViewport(): boolean {
  const { width } = useWindowDimensions();

  return width <= MOBILE_MAX_WIDTH;
}
